import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "month",
        "selectedDateLabel",
        "emptySlots",
        "slotsContainer",
        "startsAt",
        "selectedTime",
        "selectedTimeHelp",
        "submit",
        "unlockable",
        "formCard"
    ]

    connect() {
        this.currentMonthIndex = 0
        this.showCurrentMonth()
    }

    previousMonth() {
        if (this.currentMonthIndex <= 0) return

        this.currentMonthIndex -= 1
        this.showCurrentMonth()
    }

    nextMonth() {
        if (this.currentMonthIndex >= this.monthTargets.length - 1) return

        this.currentMonthIndex += 1
        this.showCurrentMonth()
    }

    selectDate(event) {
        const button = event.currentTarget
        const slots = JSON.parse(button.dataset.slots || "[]")

        this.clearSelectedDates()
        this.clearSelectedSlot()

        button.classList.add("is-selected")

        this.selectedDateLabelTarget.textContent = button.dataset.fullDateLabel

        this.slotsContainerTarget.innerHTML = ""

        slots.forEach((slot) => {
            const slotButton = document.createElement("button")
            slotButton.type = "button"
            slotButton.className = "debbie-call-time-slot"
            slotButton.textContent = slot.label
            slotButton.dataset.slotValue = slot.iso8601
            slotButton.dataset.slotLabel = `${button.dataset.fullDateLabel} at ${slot.label}`
            slotButton.addEventListener("click", () => this.selectSlot(slotButton))

            this.slotsContainerTarget.appendChild(slotButton)
        })

        this.emptySlotsTarget.classList.add("d-none")
        this.slotsContainerTarget.classList.remove("d-none")
    }

    selectSlot(button) {
        this.clearSelectedSlot()

        button.classList.add("is-selected")

        this.startsAtTarget.value = button.dataset.slotValue
        this.selectedTimeTarget.textContent = button.dataset.slotLabel
        this.selectedTimeHelpTarget.textContent = "Please complete your details to confirm your strategy call."

        this.unlockForm()
    }

    showCurrentMonth() {
        this.monthTargets.forEach((month, index) => {
            month.classList.toggle("is-active", index === this.currentMonthIndex)
        })
    }

    clearSelectedDates() {
        this.element.querySelectorAll(".debbie-call-calendar-day.is-selected").forEach((day) => {
            day.classList.remove("is-selected")
        })
    }

    clearSelectedSlot() {
        this.element.querySelectorAll(".debbie-call-time-slot.is-selected").forEach((slot) => {
            slot.classList.remove("is-selected")
        })

        this.startsAtTarget.value = ""
        this.submitTarget.disabled = true

        if (this.hasFormCardTarget) {
            this.formCardTarget.classList.add("is-locked")
        }

        this.unlockableTargets.forEach((field) => {
            field.disabled = true
        })

        this.selectedTimeTarget.textContent = "Select a time to unlock"
        this.selectedTimeHelpTarget.textContent = "Choose an available slot from the calendar to provide your details."
    }

    unlockForm() {
        this.submitTarget.disabled = false

        if (this.hasFormCardTarget) {
            this.formCardTarget.classList.remove("is-locked")
        }

        this.unlockableTargets.forEach((field) => {
            field.disabled = false
        })
    }
}